<template>
  <v-card id="promotion-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn
          color="primary"
          class="me-3"
          @click="syncRestaurants()"
        >
          <span>Синхронизировать</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>

    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="restaurants"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >

      <template #[`item.name`]="{item}">
        {{ item.name }}
      </template>

      <template #[`item.isVisible`]="{item}">
        <v-icon
          size="20"
          class="rounded-0"
          @click="updateVisibility({restaurantId: item.id, isVisible: !item.isVisible})"
        >
          {{ item.isVisible ? icons.mdiEye : icons.mdiEyeOff }}
        </v-icon>
      </template>

      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">

          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                :to="{ name: 'branch-list', params: { restaurantId: item.id } }"
              >
                <v-icon size="18">
                  {{ icons.mdiSilverwareForkKnife }}
                </v-icon>
              </v-btn>
            </template>
            <span>Филиалы</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="syncBranches({restaurantId: item.id } )"
              >
                <v-icon size="18">
                  {{ icons.mdiDownload }}
                </v-icon>
              </v-btn>
            </template>
            <span>Синхронизировать филиалы</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="updateDialogShow(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Редактирование</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <restaurant-form :label="'Конфигурация ресторана'" :cancellation="updateDialogCancel" :show="updateDialog"
                     :save="updateRestaurant"></restaurant-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import {
  mdiSilverwareForkKnife,
  mdiDownload,
  mdiPencilOutline,
  mdiEye,
  mdiEyeOff,
} from '@mdi/js'
import RestaurantForm from './restaurant-form'

export default {
  name: 'RestaurantList',
  components: { RestaurantForm },
  data: () => ({
    updateDialog: false,
    icons: { mdiSilverwareForkKnife, mdiDownload, mdiEye, mdiEyeOff, mdiPencilOutline },
  }),
  computed: {
    ...mapFormHandlers('restaurant', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('restaurant', {
      restaurants: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'Имя', value: 'name' },
        { text: 'Доступен', value: 'isVisible' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Рестораны'
    await this.fetchRestaurants()
  },
  mounted() {
  },
  methods: {
    ...mapActions('restaurant', {
      fetchRestaurants: 'fetchList',
      syncRestaurants: 'sync',
      updateVisibility: 'updateVisibility',
    }),
    ...mapActions('branch', { syncBranches: 'sync' }),
    ...mapActions('restaurant/form', ['resetForm', 'fetchConfigurationById', 'updateConfiguration']),
    updateDialogCancel() {
      this.updateDialog = false
    },
    updateDialogShow(id) {
      this.fetchConfigurationById(id)
      this.updateDialog = true
    },
    async updateRestaurant() {
      await this.updateConfiguration()
      this.updateDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
